import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, UpdateCard } from "../components";
import { handleOnClickLogout, getAllCards } from "../constants";
import { useNavigate, useParams } from "react-router-dom";

const UpdatedCard = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [initial, setInitial] = useState(false);
  const [cardData, setCardData] = useState({});
  const [cards, setCards] = useState([]);
  const { cardId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Cards"]);
  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };
  useEffect(() => {
    if (breads.length < 2 && initial) {
      navigate("/");
    }
  }, [breads]);

  useEffect(() => {
    if (cards.length > 0) {
      let cardFiltered = cards.filter((val) => val.card_id == cardId);
      if (cardFiltered.length > 0) {
        setCardData(cardFiltered[0]);
        if (breads.length == 1) {
          setBreads([...breads, cardFiltered[0].card_name]);
        }
      } else {
        navigate("/");
      }
    }
    setInitial(true);
  }, [cards]);

  useEffect(() => {
    getAllCards(token, setCards);
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={breads[0].toLocaleLowerCase()} interceptFunc={true} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            {Object.keys(cardData).length === 0 ? (
              "Loading..."
            ) : (
              <UpdateCard data={cardData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedCard;
